import { LoadingNewChatsIndicator } from '../Messaging/Sidebar/LoadingNewChatsIndicator.js'

/**
 * Skeleton for the navbar messages dropdown. Lives outside the Messaging
 * module so it can be rendered while that module is still being loaded.
 */
export const MessagingDropdownLoading = () => (
  <ul className="bg-surface overflow-hidden divide-y divide-line-subdued">
    <LoadingNewChatsIndicator />
  </ul>
)
